import { Box, CircularProgress } from '@mui/material'
import { FC } from 'react'

/**
 * ApplicationLoadingScreen
 */
export const ApplicationLoadingScreen: FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100vw',
        position: 'fixed',
        top: 0,
        left: 0,
      }}
    >
      <CircularProgress />
    </Box>
  )
}
